import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isModalOpen: false,
};

const searchModalSlice = createSlice({
  name: "searchModal",
  initialState,
  reducers: {
    openSearchModal: (state) => {
      state.isModalOpen = true;
    },
    closeSearchModal: (state) => {
      state.isModalOpen = false;
    },
  },
});

export const { openSearchModal, closeSearchModal } = searchModalSlice.actions;
export default searchModalSlice.reducer;